const ScrollingBottomToTop = () => {
    document.scrollingElement.scroll(0,0)
};

export default ScrollingBottomToTop;